import {
  FAQ_CUSTOMER_START,
  FAQ_CUSTOMER_SUCCESS,
  FAQ_CUSTOMER_ERROR,
  AEM_RENTAL_LISTING_CF_START,
  AEM_RENTAL_LISTING_CF_SUCCESS,
  AEM_RENTAL_LISTING_CF_ERROR,
} from "Constant";

const initialState = {
  loading: false,
  data: [],
  aemRentalListingCf: [],
};

export default function faqCustomerReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case FAQ_CUSTOMER_START:
      return {
        ...state,
        loading: true,
      };
    case FAQ_CUSTOMER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FAQ_CUSTOMER_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case AEM_RENTAL_LISTING_CF_START:
      return {
        ...state,
        loading: true,
      };
    case AEM_RENTAL_LISTING_CF_SUCCESS:
      return {
        ...state,
        aemRentalListingCf: action.payload,
        loading: false,
      };
    case AEM_RENTAL_LISTING_CF_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
